import ClassementService from '../services/classement.service';

const state = {
    classement: [],
    topPlayers: [],
    globalStats: null,
    loading: false,
    error: null
};

const getters = {
    allClassement: state => state.classement,
    topPlayers: state => state.topPlayers,
    globalStats: state => state.globalStats,
    isLoading: state => state.loading,
    error: state => state.error
};

const actions = {
    fetchClassement({ commit }) {
        commit('setLoading', true);
        return ClassementService.getClassement()
            .then(response => {
                commit('setClassement', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération du classement');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    fetchTopPlayers({ commit }) {
        commit('setLoading', true);
        return ClassementService.getTopPlayers()
            .then(response => {
                commit('setTopPlayers', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération des meilleurs joueurs');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    fetchGlobalStats({ commit }) {
        commit('setLoading', true);
        return ClassementService.getGlobalStats()
            .then(response => {
                commit('setGlobalStats', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération des statistiques globales');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    clearError({ commit }) {
        commit('setError', null);
    }
};

const mutations = {
    setClassement(state, classement) {
        state.classement = classement;
    },
    setTopPlayers(state, topPlayers) {
        state.topPlayers = topPlayers;
    },
    setGlobalStats(state, stats) {
        state.globalStats = stats;
    },
    setLoading(state, status) {
        state.loading = status;
    },
    setError(state, error) {
        state.error = error;
    }
};

export const classement = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 